import { Button, Card, Divider, List, Typography, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { EmptyState } from "../EmptyState";
import { useAuth } from "../../lib/auth";
import type { AttachmentItem } from "./types";

interface AttachmentsTabProps {
  attachments: AttachmentItem[];
  uploading: boolean;
  onUpload: (file: File | undefined) => Promise<void> | void;
}

export default function AttachmentsTab({
  attachments,
  uploading,
  onUpload,
}: AttachmentsTabProps) {
  const { canWrite } = useAuth();
  return (
    <Card title="Attachments">
      {attachments.length === 0 ? (
        <EmptyState description="No files attached yet." />
      ) : (
        <List
          aria-label="Project file attachments"
          dataSource={attachments}
          renderItem={(attachment) => (
            <List.Item>
              <List.Item.Meta
                title={
                  <Typography.Link href={attachment.url} target="_blank" rel="noreferrer">
                    {attachment.name}
                  </Typography.Link>
                }
                description={
                  attachment.createdAt
                    ? new Date(attachment.createdAt).toLocaleDateString()
                    : undefined
                }
              />
            </List.Item>
          )}
        />
      )}
      {canWrite && (
        <>
          <Divider />
          <Upload
            showUploadList={false}
            beforeUpload={(file) => {
              void onUpload(file);
              return false;
            }}
          >
            <Button
              icon={<UploadOutlined />}
              loading={uploading}
              aria-label="Upload file to project"
            >
              Upload File
            </Button>
          </Upload>
        </>
      )}
    </Card>
  );
}
